const LOCALE = "es-MX";

export const APP_VERSION = "panel-web-0.3.0";

function pad(n: number) {
  return String(n).padStart(2, "0");
}

export function fmtDateTime(iso?: string | null): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(LOCALE, { dateStyle: "short", timeStyle: "medium" }).format(new Date(iso));
}

export function fmtTime(iso?: string | null): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(LOCALE, { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }).format(new Date(iso));
}

export function fmtDayShort(iso?: string | null): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(LOCALE, { day: "numeric", month: "short" }).format(new Date(iso)).replace(".", "");
}

export function fmtDate(iso?: string | null): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(LOCALE, { dateStyle: "medium" }).format(new Date(iso));
}

export function fmtNum(n?: number | null, digits = 2): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return new Intl.NumberFormat(LOCALE, { maximumFractionDigits: digits, minimumFractionDigits: 0 }).format(n);
}

export function fmtPct(n?: number | null): string {
  return n === null || n === undefined ? "—" : `${fmtNum(n, 1)} %`;
}

export function localDateStr(d: Date = new Date()): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function parseLocal(dateStr: string): Date {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function startIso(dateStr?: string | null): string | undefined {
  return dateStr ? parseLocal(dateStr).toISOString() : undefined;
}

export function endIso(dateStr?: string | null): string | undefined {
  if (!dateStr) return undefined;
  const d = parseLocal(dateStr);
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
}

export function addDays(dateStr: string, days: number): string {
  const d = parseLocal(dateStr);
  d.setDate(d.getDate() + days);
  return localDateStr(d);
}

export function rangeIncludesToday(from?: string | null, to?: string | null): boolean {
  const today = localDateStr();
  return (!from || from <= today) && (!to || to >= today);
}

export function shortId(s?: string | null, n = 8): string {
  if (!s) return "—";
  return s.length > n ? `${s.slice(0, n)}…` : s;
}

export function getDeviceId(): string {
  const k = "insp.device_id";
  let id = localStorage.getItem(k);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(k, id);
  }
  return id;
}
